export default function Spinner({ className }: { className?: string }) {
  return (
    <div
      className={`size-8 border-3 border-gray-200 border-t-gray-700 rounded-full animate-spin ${className ?? ''}`}
      aria-label="Loading"
    />
  )
}
